export enum PageEnum {
  BASE_LOGIN = '/login',
  BASE_HOME = '/home/index',
  // error page path
  ERROR_PAGE = '/exception',
  // error log page path
  ERROR_LOG_PAGE = '/error-log/list',
}
